/**
 * RISK-HELP.MODAL
 * Description of each item for risk module
 */

import Modal from "@/components/modal"
import { useTranslation } from "react-i18next"
import { HelpKey, RISK_HELP_ITEMS } from "@/features/risks/entities/risk/model/risk.help.config"

interface OwnProps {
  item: HelpKey
  onClose: Function
}

export default function RiskHelpModal({ item, onClose }: OwnProps) {
  const { t } = useTranslation()
  const help = RISK_HELP_ITEMS.find((x) => x.id === item)
  if (!help) return null

  return (
    <Modal isCloseButtonVisible onClose={onClose} title={t(help.name)}>
      {help.descriptions.map((key, i) => (
        <p key={i}>{t(key)}</p>
      ))}
    </Modal>
  )
}
